import { makeObservable, observable, action } from 'mobx';
import BaseObjectStore from './base-object.store';

class WorkoutAssignmentStore extends BaseObjectStore {
  selectedDate = null;

  constructor(props) {
    super(props);
    this.name = 'workoutAssignment';
    makeObservable(this, {
      selectedDate: observable,
      setSelectedDate: action
    });
  }

  setSelectedDate(selectedDate) {
    this.selectedDate = selectedDate;
    return this.selectedDate;
  }

  getSelectedDate() {
    return this.selectedDate;
  }

  resetAllFields() {
    this.resetAllBaseFields();
    this.setSelectedDate(null);
  }
}

export default new WorkoutAssignmentStore();
